import i18next from "i18next";
import {CaptchaWidget} from "../../widget/CaptchaWidget";
import React from "react";
import {Col, Input, Modal, Row} from "antd";
import {ReloadOutlined, SafetyOutlined} from "@ant-design/icons";
import * as UserBackend from "../../services/UserBackend";
import * as Setting from "../../conf/Setting";

export const Captcha = (props) => {
  const {application, handleConfirm} = props;
  const [visible, setVisible] = React.useState(false);
  const [checkType, setCheckType] = React.useState("");
  const [checkId, setCheckId] = React.useState("");
  const [subType, setSubType] = React.useState("");
  const [clientId, setClientId] = React.useState("");
  const [clientId2, setClientId2] = React.useState("");
  const [clientSecret2, setClientSecret2] = React.useState("");
  const [captchaImg, setCaptchaImg] = React.useState("");
  const [key, setKey] = React.useState("");
  const [buttonDisabled, setButtonDisabled] = React.useState(true);

  React.useImperativeHandle(props.onRef, () => {
    // 将暴露的接口返回出去
    return {
      getCaptcha: getCaptcha,
    };
  });

  const getCaptcha = () => {
    UserBackend.getCaptcha(application.owner, application.uid, false).then(res => {
      if (res.type === "none") {
        setVisible(false);
        handleConfirm();
      } else if (res.type === "Default Captcha") {
        setCheckId(res.captchaId);
        setCaptchaImg(res.captchaImage);
        setCheckType("Default Captcha");
        setVisible(true);
      } else {
        setCheckType(res.type);
        setClientId(res.clientId);
        setCheckId(res.clientSecret);
        setSubType(res.subType);
        setClientId2(res.clientId2);
        setClientSecret2(res.clientSecret2);
        setVisible(true);
      }
    });
  };

  const handleOk = () => {
    if (key === "") {
      return;
    }
    UserBackend.verifyCaptcha2(checkType, key, checkId).then((res) => {
      if (res.status === "ok") {
        if (res.data) {
          setKey("");
          setVisible(false);
          handleConfirm();
        } else {
          Setting.showMessage("error", i18next.t("user:Captcha Verify Failed"));
          getCaptcha();
          return false;
        }
      } else {
        Setting.showMessage("error", i18next.t("user:" + res.msg));
        return false;
      }
    });
  };

  const handleCancel = () => {
    setVisible(false);
    setKey("");
  };

  const renderCaptcha = () => {
    return (
      <Col>
        <Row type="flex" align="bottom">
          <Col style={{
            backgroundImage: `url('data:image/png;base64,${captchaImg}')`,
            backgroundRepeat: "no-repeat",
            height: "80px",
            width: "200px",
            borderRadius: "5px",
            border: "1px solid #ccc",
            marginBottom: 10,
          }} />
          <ReloadOutlined style={{fontSize: 16, marginLeft: 6, marginBottom: 10}} onClick={() => {
            getCaptcha();
          }} />
        </Row>
        <Row>
          <Input autoFocus
            value={key}
            prefix={<SafetyOutlined />}
            placeholder={i18next.t("general:Captcha")}
            onPressEnter={handleOk}
            onChange={e => setKey(e.target.value)} />
        </Row>
      </Col>
    );
  };

  const onSubmit = (token) => {
    setButtonDisabled(false);
    setKey(token);
  };

  const renderCheck = () => {
    if (checkType === "Default Captcha") {
      return renderCaptcha();
    } else {
      return (
        <CaptchaWidget
          captchaType={checkType}
          subType={subType}
          siteKey={clientId}
          clientSecret={checkId}
          onChange={onSubmit}
          clientId2={clientId2}
          clientSecret2={clientSecret2}
        />
      );
    }
  };

  return (
    <Modal
      closable={false}
      maskClosable={false}
      destroyOnClose={true}
      title={i18next.t("general:Captcha")}
      visible={visible}
      okText={i18next.t("user:OK")}
      cancelText={i18next.t("user:Cancel")}
      onOk={handleOk}
      onCancel={handleCancel}
      okButtonProps={{disabled: key.length !== 5 && buttonDisabled}}
      width={348}
    >
      {
        renderCheck()
      }
    </Modal>
  );
};

export default Captcha;
